import React from "react";

function ErrorPage() {
  return <h1>Oops! Page not found!</h1>;
}

export default ErrorPage;
